import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import autoBind from 'react-autobind';
import classnames from 'classnames';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import FormError from 'ui/common/form/form-error';
import CheckboxField from 'ui/common/form/fields/checkbox-field';
import SubmitButton from 'ui/common/form/submit-button';
import RequestedDelete from 'ui/users/details/requested-delete';
import styles from './index.module.scss';
import validator from 'ui/common/form/validator';
import model, { fieldNames } from './model';
import * as messages from './messages';
import routeTemplates from 'ui/common/routes/templates';
import { acceptCurrentTermsAndPrivacy } from 'store/features/auth/actions';
import { selectCurrentUserDeletionRequestedAt } from 'store/features/auth/selectors';

const { request: acceptCurrentTermsAndPrivacyRequest } = acceptCurrentTermsAndPrivacy;

const FORM_NAME = 'consent';

const validate = validator(model);

class Consent extends Component {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  onSubmit(values) {
    const { acceptCurrentTermsAndPrivacyRequest, form } = this.props;

    acceptCurrentTermsAndPrivacyRequest(values, form);
  }

  render() {
    const {
      currentUserDeletionRequestedAt,
      handleSubmit,
      form: formName,
      intl: { formatMessage },
    } = this.props;

    if (currentUserDeletionRequestedAt) {
      return <RequestedDelete />;
    }

    return (
      <div className={classnames('py-4 container', styles.page)}>
        <Helmet>
          <title>{formatMessage(messages.header.title)}</title>
        </Helmet>
        <div
          className={classnames('row justify-content-center align-items-center', styles.pageRow)}
        >
          <div className="col-12 col-sm-6">
            <h1 className="text-center">
              <FormattedMessage id="header.privacy-policy" defaultMessage="Ngee Ann Polytechnic" />
            </h1>
            <h2 className="text-center">{formatMessage(messages.header.title)}</h2>
            <h4 className="text-center pb-3">{formatMessage(messages.content.declarationTitle)}</h4>
            <ul className="pb-3">
              <li>{formatMessage(messages.content.declarationContentOne)}</li>
              <li>{formatMessage(messages.content.declarationContentTwo)}</li>
              {/* <li>{formatMessage(messages.content.declarationContentThree)}</li> */}
              <li>{formatMessage(messages.content.declarationContentFour)}</li>
              <li>{formatMessage(messages.content.declarationContentFive)}</li>
            </ul>
            <h4 className="text-center pb-3">{formatMessage(messages.content.termsOfUseTitle)}</h4>
            <p className="pb-3">
              <FormattedMessage
                {...messages.content.termsOfUseContent}
                values={{
                  privacy: (
                    <a href="https://www.np.edu.sg/Pages/privacy.aspx">
                      Terms of use (Privacy Statement)
                    </a>
                  ),
                }}
              />
            </p>
            <form
              title={formatMessage(messages.header.title)}
              onSubmit={handleSubmit(this.onSubmit)}
            >
              <FormError formName={formName} />
              <div>
                <Field
                  name={fieldNames.acceptTermsAndConditions}
                  component={CheckboxField}
                  label={
                    <FormattedMessage
                      {...messages.labels.acceptTermsAndConditions}
                      values={{
                        privacy: (
                          <a href="https://www.np.edu.sg/Pages/privacy.aspx">Privacy Policy</a>
                        ),
                      }}
                    />
                  }
                />
              </div>
              <div className="mt-3 text-center">
                <SubmitButton formName={FORM_NAME}>
                  {formatMessage(messages.buttons.submit)}
                </SubmitButton>
              </div>
            </form>
            <hr />
            <p className="text-muted">
              <small>
                <FormattedMessage
                  {...messages.content.chooseToDelete}
                  values={{
                    link: <Link to={routeTemplates.users.delete}>permanently delete</Link>,
                  }}
                />
              </small>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUserDeletionRequestedAt: selectCurrentUserDeletionRequestedAt(state),
  };
}

const mapDispatchToProps = { acceptCurrentTermsAndPrivacyRequest };

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: FORM_NAME,
    validate,
  })(injectIntl(Consent))
);



// WEBPACK FOOTER //
// ./src/ui/auth/consent/index.js